import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import mixinHelper from '@/helpers/mixinHelper';

// Routes
Vue.use(Router);

export const routes = [
  {
    path: '/',
    redirect: '/project'
  },
  {
    path: '/project',
    name: 'project',
    component: () => import('@/pages/configurator/Project.vue'),
    props: true
  },
  {
    path: '/checkout',
    name: 'checkout',
    component: () => import('@/pages/CheckoutPage.vue'),
    meta: {
      layout: 'onePage'
    }
  },
  {
    path: '/verifyEmail',
    name: 'verifyEmail',
    component: () => import('@/pages/authentication/VerifyEmailPage.vue'),
    meta: {
      layout: 'onePage'
    }
  },
  {
    path: '/resetPassword',
    name: 'resetPassword',
    component: () => import('@/pages/authentication/ResetPasswordPage.vue'),
    meta: {
      layout: 'onePage'
    }
  },
  {
    path: '/orderSummary',
    name: 'orderSummary',
    component: () => import('@/pages/configurator/OrderSummaryPage.vue')
  },
  {
    path: '/subsystem',
    name: 'subsystem',
    component: () => import('@/pages/configurator/Subsystem.vue')
  },
  {
    path: '/account',
    name: 'account',
    component: () => import('@/pages/configurator/AccountPage.vue'),
    props: true
  },
  {
    path: '/reports',
    name: 'reports',
    component: () => import('@/pages/configurator/Reports.vue')
  },
  {
    path: '/blank',
    name: 'blank',
    component: () => import('@/pages/BlankPage.vue')
  },
  {
    path: '/error',
    component: () => import('@/pages/ErrorPage.vue'),
    meta: {
      layout: 'error'
    }
  },
  {
    path: '/mobile',
    component: () => import('@/pages/MobilePage.vue'),
    meta: {
      layout: 'mobile'
    }
  },
  {
    path: '*',
    name: 'not-found',
    component: () => import('@/pages/NotFoundPage.vue'),
    meta: {
      layout: 'error'
    }
  }
];

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL || '/',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;

    return { x: 0, y: 0 };
  },
  routes
});

/**
 * Before each route update
 */
router.beforeEach((to, from, next) => {
  if (to.name != 'checkout' && store.state.checkout.projectId > 0) {
    mixinHelper.methods.resetCheckout();
  }
  return next();
});

/**
 * After each route update
 */
router.afterEach(() => {});

export default router;
